export var PresetNames;
(function (PresetNames) {
    PresetNames["BASIC"] = "basic";
    PresetNames["BASIC_WHITELIST"] = "basic_whitelist";
})(PresetNames || (PresetNames = {}));
// TODO: Add the preset configurations, alias for workflow templates, etc. More detail on what they insert etc
export const PRESETS = {
    [PresetNames.BASIC]: {
        label: `Basic`,
        name: PresetNames.BASIC,
        description: `A single late fee policy, assigned to the default customer group. All your invoices will use these settings when applying late fees`,
    },
    [PresetNames.BASIC_WHITELIST]: {
        label: `Basic template + Whitelist`,
        name: PresetNames.BASIC_WHITELIST,
        description: `The same as the "Basic template", but with an extra group - configured as a whitelist. Ideal for when you don't want to apply late fees to some contacts`,
    },
};
//# sourceMappingURL=presets.js.map